import React, { useMemo } from 'react';
import { Button } from '@mui/material';
import { Add } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { openDialog } from '@/features/dialog/dialogSlice';
import { useObjectContext } from '@/hooks/useObjectContext';
import { usePipelineContext } from '@/context/pipelineContext';
import { useFeatureFlagContext } from '@/context/featureFlagContext';

export const EditPolicyTransactionButton = ({ minimal = false, policy = {} }) => {
	const dispatch = useDispatch();
	const { dealRow } = useObjectContext();

	const dealStage = dealRow?.dealStage;

	const { closed } = usePipelineContext(dealRow?.pipeline);

	const { getFeatureFlags } = useFeatureFlagContext();
	const showButton = Boolean(getFeatureFlags('addPolicyTransactions')?.active);

	const isRenewal = dealRow?.pipeline === process.env.REACT_APP_PIPELINE_RENEWALS;
	const isEndorsement = dealRow?.pipeline == process.env.REACT_APP_PIPELINE_ENDORSEMENTS;
	const isDebtor = dealRow?.pipeline == process.env.REACT_APP_PIPELINE_DEBTORS;

	const handleOpenDialog = () => {
		dispatch(
			openDialog({
				dialogName: 'editPolicyTransaction',
				data: { type: 'transaction', policy: policy },
				// data: { type: isDebtor ? 'transaction' : 'policy' },
			}),
		);
	};

	const shouldShowButton = useMemo(() => {
		if (isRenewal || isEndorsement || isDebtor) return true;
		return closed.includes(dealStage) && showButton;
	}, [isRenewal, isEndorsement, isDebtor, dealStage, showButton, closed]);

	return shouldShowButton ? (
		<Button
			variant={minimal ? 'outlined' : 'tab_header'}
			startIcon={<Add />}
			sx={{ borderRadius: '10px' }}
			onClick={handleOpenDialog}
		>
			{isDebtor ? 'Add invoice' : 'Add policy transaction'}
		</Button>
	) : null;
};
